import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID, proformas) {
  const promises = [];

  proformas.map((proforma) => {
    const config = {
      headers: {
        idUsuario: IDUSUARIO,
      },
    };

    return (
      promises.push(
        customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/proformas/${proforma.numProfVeh}/colores`, config)
          .then(({ data }) => {
            if (data.estadoTrama === '1') {
              return { [proforma.numProfVeh]: data.colorProforma };
            }
            console.log(data.estadoTrama);
            return 'error';
          })
      ));
  });

  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./src/utils/getColorsProform.js